import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";

const GhostLanding = () => {
  const navigate = useNavigate();
  useEffect(() => { document.title = "AXIORA"; }, []);

  return (
    <div
      data-testid="ghost-landing"
      className="min-h-screen w-full flex flex-col items-center justify-center bg-[#050505] relative overflow-hidden px-6"
    >
      <div
        className="absolute inset-0 opacity-[0.07] pointer-events-none"
        style={{ background: "radial-gradient(circle at 50% 40%, #D4AF37 0%, transparent 55%)" }}
      />
      <div className="absolute inset-0 pointer-events-none" style={{
        backgroundImage: "linear-gradient(rgba(255,255,255,0.015) 1px, transparent 1px), linear-gradient(90deg, rgba(255,255,255,0.015) 1px, transparent 1px)",
        backgroundSize: "44px 44px",
      }} />

      <div className="relative z-10 flex flex-col items-center ax-fade-up">
        <button
          data-testid="brand-entry"
          onClick={() => navigate("/acceso-comando")}
          className="flex flex-col items-center focus:outline-none cursor-pointer group"
          aria-label="AXIORA"
        >
          <h1 className="font-serif-ax text-6xl sm:text-7xl lg:text-8xl tracking-[0.18em] ax-gold-text select-none transition-transform duration-500 group-hover:scale-[1.03]">
            AXIORA
          </h1>
          <div className="mt-6 h-px w-40 bg-gradient-to-r from-transparent via-[#D4AF37]/60 to-transparent transition-all duration-500 group-hover:w-56" />
          <p className="mt-6 text-[#71717A] text-sm tracking-[0.35em] uppercase group-hover:text-[#A1A1AA] transition-colors">
            Análisis · Estadística · Precisión
          </p>
        </button>
      </div>

      {/* Entrada secreta: punto casi invisible, solo el dueño la conoce */}
      <button
        data-testid="secret-entry-dot"
        aria-label="."
        onClick={() => navigate("/acceso-comando")}
        className="absolute bottom-6 right-6 z-20 w-3 h-3 rounded-full bg-[#151515] hover:bg-[#D4AF37]/70 transition-colors duration-500"
        title=""
      />
    </div>
  );
};

export default GhostLanding;
